'use strict';

(function () {

  'use strict';

  angular.module('specsguardApp')
    .factory('transitionNotifierInterceptor', transitionNotifierInterceptor);

  transitionNotifierInterceptor.$inject = ['$rootScope', '$q'];

  function transitionNotifierInterceptor ($rootScope, $q) {

    return {
      request: function (request) {
        // overrideInterceptor can be configured in the api resource, to implement a custom loading spinner
        if (request.method !== 'GET' && !request.overrideInterceptor) {
          $rootScope.$emit('transitionnotifier:start');
        }

        return request;
      },

      response: function (response) {
        if (response.config.method !== 'GET') {
          $rootScope.$emit('transitionnotifier:end');
        }

        return response;
      },

      responseError: function (response) {
        if (response.config && response.config.method !== 'GET') {
          $rootScope.$emit('transitionnotifier:end');
        }

        return $q.reject(response);
      }
    };
  }

})();

